import { useSelector } from 'react-redux';

import { safeDivide } from '../../../../../../utils/safeDivide';

const useMessagesAverages = () => {
  const messages = useSelector((state) => state.resonance.messages);

  const r1Average = divideToFixed(getSumByKey('r1Total', messages), messages.length);
  const r2Average = divideToFixed(getSumByKey('r2Total', messages), messages.length);

  return { r1Average, r2Average };
};

export default useMessagesAverages;

const getSumByKey = (key, options) => {
  if (!key || !options || !options.length) {
    return 0;
  }

  if (options.every((option) => !option[key])) {
    return null;
  }

  const optionsSum = options.reduce((sum, message) => {
    const value = message[key] || 0;

    return (sum += value);
  }, 0);

  return optionsSum;
};

const divideToFixed = (a, b) => {
  if (a === null || b === null) {
    return null;
  }

  return safeDivide(a, b).toFixed(2);
};
